"use client";
import { Section } from "@/app/lib/features/home/home.types";
import TrendCategoryCard from "../../elements/cards/trendCategoryCard/TrendCategoryCard";
import { useTrackView } from "@/app/hooks/useTrackView";

interface CategoriesDiscoverSectionProps {
  section: Section;
}

const CategoriesDiscoverSection = ({
  section,
}: CategoriesDiscoverSectionProps) => {
  const trackRef = useTrackView("section", section.id);

  if (!section.items || section.items.length === 0) {
    return null;
  }

  return (
    <section ref={trackRef} className="grid grid-cols-12 gap-4">
      <div className="col-span-12 lg:col-span-4 text-center flex items-center justify-center flex-col space-y-2 p-2 sm:p-4">
        <h2 className="text-lg sm:text-xl lg:text-2xl font-medium">
          {section.title}
        </h2>
        <div className="w-1/2 sm:w-2/3 bg-black h-px"></div>
        <p className="text-xl sm:text-2xl lg:text-[42px] font-medium leading-tight lg:leading-12 px-2">
          {section.description}
        </p>
      </div>
      <div className="col-span-12 lg:col-span-8 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3 lg:gap-6">
        {section.items.map((item, index) => (
          <TrendCategoryCard key={item.id} item={item} priority={index < 2} />
        ))}
      </div>
    </section>
  );
};

export default CategoriesDiscoverSection;
